// power/laundry-line.jsx — the home-screen line for the laundry spike hold.
//
// Same shape as the plants line (a rust dot and a sentence, shown only
// while there is something to know), plus Run anyway, which turns on
// input_boolean.laundry_spike_override: HA switches both plugs back on and
// suspends the hold until the spike clears.

import * as React from 'react';
import { fs } from '../direction-a.jsx';
import { FONT, RADIUS } from '../theme.js';
import { LAUNDRY } from './laundry.js';

export function LaundryLine({ T, laundry, hass }) {
  const line = laundry?.line;
  const [pending, setPending] = React.useState(false);
  // The override arriving (or the line going away) settles the button.
  React.useEffect(() => { setPending(false); }, [laundry?.override, !!line]);
  if (!line) return null;

  const runAnyway = () => {
    if (!hass?.callService || pending) return;
    setPending(true);
    Promise.resolve(hass.callService('input_boolean', 'turn_on', { entity_id: LAUNDRY.override }))
      .catch(() => setPending(false));
  };

  return (
    <div role="status" style={{
      display: 'flex', alignItems: 'center', gap: 12, width: '100%', boxSizing: 'border-box',
      padding: '12px 14px 12px 20px', borderRadius: RADIUS.control, background: T.card, boxShadow: T.cardShadow,
      fontFamily: FONT.sans, color: T.ink,
    }}>
      <span aria-hidden style={{ width: 9, height: 9, borderRadius: '50%', background: T.attention, flexShrink: 0 }}/>
      <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0, flex: '1 1 auto' }}>
        <span style={{ fontSize: fs(T, 16), fontWeight: 600, color: T.attention }}>{line.text}</span>
        <span style={{ fontSize: fs(T, 15), color: T.inkSoft, lineHeight: 1.3 }}>{line.sub}</span>
      </span>
      {line.canRunAnyway && (
        <button onClick={runAnyway} disabled={pending} style={{
          marginLeft: 'auto', flexShrink: 0, padding: '8px 14px', border: 'none', borderRadius: RADIUS.full,
          background: T.cardSoft, color: T.ink, fontFamily: FONT.sans, fontSize: fs(T, 14), fontWeight: 600,
          cursor: pending ? 'default' : 'pointer', opacity: pending ? .6 : 1,
        }}>{pending ? 'Starting…' : 'Run anyway'}</button>
      )}
    </div>
  );
}
